import React from "react";
import ResetPassword from "../../ResetPassword/ResetPassword";
import "./reset-password-modal.style.scss";
export default function ResetPasswordModal({ closeIt }) {
  return (
    <div onClick={() => closeIt()} className="candidate-landing-modal-main">
      <div
        onClick={(e) => e.stopPropagation()}
        className="candidate-landing-modal"
      >
        <ResetPassword modal={true} closeIt={closeIt} />
      </div>
    </div>
  );
}
